import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'success',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Success"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("h1", null, " Success ", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, " Payment succeeded, thank you for using RutSolve! ", -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})